export default {
    linkList : {
        "operationPolicy": "سياسة الاستخدام",
        "communityPolicy": "السياسة المجتمعية",
        "youthProtectionPolicy": "سياية حماية القاصرين",
        "declarationOfSafety": "إعلان ألأمن والتأمين",
        "cookiePolicy": "سياسة سجل التتبع",
        "customerSupport": "خدمة العملاء",
        "guaranteeOfRights": "كفالة الحقوق",
        "privacyPolicy": "الخصوصية",
        "termsOfService": "شروط الخدمة",
        "companyLink": "مقدمة الشركة",
        "doNotSell": "Do Not Sell My Personal Information",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
    },
    footerWords:{
        "gameRelatedLaw": "علامة إضافية وفقًا للقوانين المتعلقة باللعبة",
        "brandInformation": "معلومات العلامة التجارية",
        "copyright": "حقوق التأليف والنشر",
        "channelingInfo": "NCSOFT Co.، Ltd. هي شركة وسيطة لشركات التعامل التجاري بالمراسلة. هي تتوسط في توفير ألعاب داخل plaync وليست معنية بالتعامل التجاري بالمراسلة مباشرة.<br>جميع الالتزامات والمسؤوليات المتعلقة بتوفير الألعاب خاصة بشركات التعامل التجاري بالمراسلة، ونحن لا نتحمل مسؤولية أي مشاكل تنشأ فيما يتعلق بذلك."
    },
    infoCS:{
        "businessInformation": "التحقق من المعلومات التجارية",
        "infoAddress": "اسم الشركة NCsoft Co.، Ltd. الرئيس التنفيذي كيم تايك جين رقم تسجيل الأعمال 144-85-04244 تقرير أعمال الطلب عبر البريد 2013-Gyeonggi Seongnam-1268",
        "mobile": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1566-7004  الفاكس:+82-2-2186-3499",
        "pc": "",
        "other": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1600-0020(ألعاب الكمبيوتر), +82-1566-7004(ألعاب الجوال)  الفاكس:+82-2-2186-3550(ألعاب الكمبيوتر), +82-2-2186-3499(ألعاب الجوال)",
        "none": '',
        "infoEmail": "البريد الإلكتروني",
        
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(ألعاب الكمبيوتر)/MobileCS@ncsoft.com/(ألعاب الجوال)",
        "infoEmail-none": "",
    },
    infoJP:{
        "jpReleaseDayValue_LW": "4نوفمبر 2021",
        "jpReleaseDay": "يوم الاصدار",
        "jpDevelopedBy": "مطور/مشغل من طرف",
        "jpOs": "نظام تشغيل المراسلات",
        "jpPriceValue": "(مجاني (يحتوي على مشتريات داخل التطبيق",
        "jpPrice": "السعر",
        "jpGenre": "نوع",
        "jpTitle": "عنوان",
    },
    "country": {
        "HK": "هونغ كونغ",
        "PH": "الفيليبين",
        "TH": "تايلاند",
        "QA": "قطر",
        "JP": "اليابان",
        "ID": "أندونيسيا",
        "AE": "الإمارات العربية المتحدة",
        "SG": "سنغافورة",
        "SA": "المملكة العربية السعودية",
        "MY": "ماليزيا",
        "RU": "روسيا",
        "TW": "تايوان",
        "KR": "جمهورية كوريا الجنوبية",
        "UA": "أوكرانيا",
        "BY": "بيلاروس",
        "LT": "ليتوانيا",
        "PL": "بولندا",
        "GR": "اليونان",
        "IL": "إسرائيل",
        "KW": "الكويت",
        "AT": "النمسا",
        "US": "الولايات المتحدة الأمريكية",
        "CA": "كندا",
        "DE": "ألمانيا",
        "GB": "بريطانيا",
        "FR": "فرنسا",
        "BR": "البرازيل",
        "IT": "إيطاليا",
        "ES": "إسبانيا",
        "CL": "تشيلي",
        "NO": "النرويج",
        "SE": "السويد",
        "IE": "أيرلندا",
        "PT": "البرتغال",
        "FI": "فنلندا",
        "DK": "الدنمارك",
        "CH": "سويسرا",
        "AR": "الأرجنتين",
        "PE": "بيرو",
        "MX": "المكسيك",
        "KZ": "كازاخستان",
        "UZ": "أوزبكستان",
        "AZ": "أذربيجان",
        "GE": "جورجيا",
        "MD": "مولدوفا",
        "AM": "أرمينيا",
        "NC": "Global"
    }
};